import React, { useMemo, useRef, useState } from 'react';
import { EventDetailsMainInner } from '../EventDetails/EventDetails';
import { AgendaReadMoreButton } from '../EventDetails/Widgets/NewAgenda/AgendaReadMoreButton';
import { AgendaTitle } from '../EventDetails/Widgets/NewAgenda/AgendaTitle';
import { AgendaView } from '../EventDetails/Widgets/NewAgenda/AgendaView';
import { AgendaWidget } from '../EventDetails/Widgets/NewAgenda/types';
import { DEFAULT_MAX_SLOTS, INFINITE } from './constants';

export const AgendaSection = ({ agenda }: { agenda?: AgendaWidget }) => {
    const [maxSlots, setMaxSlots] = useState(DEFAULT_MAX_SLOTS);
    const [activeTab, setActiveTab] = useState(agenda?.tabs[0]);
    const agendaTabsRef = useRef<HTMLDivElement>(null);

    const shouldShowModal = useMemo(
        () =>
            activeTab?.slots
                ? activeTab.slots.length > DEFAULT_MAX_SLOTS
                : false,
        [activeTab],
    );

    if (!agenda || agenda.tabs.length === 0) {
        return null;
    }

    const handleReadMoreClick = () => {
        setMaxSlots(
            maxSlots === DEFAULT_MAX_SLOTS ? INFINITE : DEFAULT_MAX_SLOTS,
        );
    };

    return (
        <EventDetailsMainInner>
            <AgendaTitle tabRef={agendaTabsRef} />
            <AgendaView
                tabs={agenda.tabs}
                agendaTabsRef={agendaTabsRef}
                maxSlots={maxSlots}
                onActiveTabChange={setActiveTab}
            />
            {shouldShowModal && (
                <AgendaReadMoreButton
                    onReadMoreClick={handleReadMoreClick}
                    tabs={agenda.tabs}
                />
            )}
        </EventDetailsMainInner>
    );
};
